import type { IconProps } from './types';
import './icons.css';

export default function SelectedCircle({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-hint ${className || ''}`}
    >
      <g fill="currentColor">
        <path d="M11.138 7.138a.667.667 0 1 0-.943-.943L7.333 9.057l-.862-.862a.667.667 0 1 0-.943.943l1.334 1.333c.26.26.682.26.942 0l3.334-3.333Z" />
        <path
          fillRule="evenodd"
          d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333ZM2.666 8a5.333 5.333 0 1 1 10.667 0A5.333 5.333 0 0 1 2.666 8Z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}
